import { attractionTypeCrudConfig } from '@/config/objects/attraction-types';
import { CrudListView, PageContainer } from '@startupquickstart/frontend';

/**
 * Attraction Types list page
 */
export function AttractionTypesPage() {
  const breadcrumbs = [
    { label: 'Home', href: '/' },
    { label: 'Attraction Types', current: true },
  ];

  return (
    <PageContainer>
      <CrudListView config={attractionTypeCrudConfig} baseUrl="/attraction-types" breadcrumbs={breadcrumbs} />
    </PageContainer>
  );
}
